import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/providers/all/")({
  beforeLoad: ({ context }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (organizationBusinessUnitId) {
      throw redirect({
        to: "/org/bu/$organizationBusinessUnitId/providers/all",
        params: { organizationBusinessUnitId },
      });
    }
    // No org — the directory requires a business unit; send org-less users
    // to the providers shared with them directly instead.
    throw redirect({ to: "/org/providers/shared" });
  },
});
